function filteredLocation(locationQuery) {
  return allLocations.filter(location => {
    return location.locationName
      .toLowerCase()
      .includes(locationQuery.toLowerCase());
  });
}

function findByLocationId(id) {
  return allLocations.filter(location => {
    return location.vuka_id == id;
  });
}

function getLocationName(airport_code) {
  if(airport_code.length > 3) return airport_code;

  let location = allLocations.find(locationObject => {
    if(locationObject.hasOwnProperty('airport_code') && locationObject.airport_code == airport_code) {
      return locationObject;
    }
  });

  if(location == undefined) {
    return '';
  }

  return location.locationName;
}

const allLocations = [
  {
    vuka_id: 1,
    airport_code: "BFN",
    locationName: "Bram Fischer International Airport, Bloemfontein, Freestate",
    providers: ["Europcar", "RentalCars", "Avis", "First", "Tempest", "All"]
  },
  {
    vuka_id: 2,
    airport_code: "CPT",
    locationName: "Cape Town International Airport, Cape Town, Western Cape",
    providers: ["Europcar", "RentalCars", "Avis", "First", "Tempest", "All"]
  },
  {
    vuka_id: 3,
    airport_code: "ELS",
    locationName: "East London Airport, Eastern Cape",
    providers: ["Europcar", "RentalCars", "Avis", "First", "Tempest", "All"]
  },
  {
    vuka_id: 4,
    airport_code: "GRJ",
    locationName: "George Airport, George, Western Cape",
    providers: ["Europcar", "RentalCars", "Avis", "First", "Tempest", "All"]
  },
  {
    vuka_id: 5,
    airport_code: "HDS",
    locationName: "Hoedspruit Airport, Limpopo",
    providers: ["RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 6,
    airport_code: "KIM",
    locationName: "Kimberley Airport, Kimberley, Northern Cape",
    providers: ["Europcar", "RentalCars", "Avis", "First", "Tempest", "All"]
  },
  {
    vuka_id: 7,
    airport_code: "DUR",
    locationName: "King shaka International Airport, Durban, KwaZulu-Natal",
    providers: ["Europcar", "RentalCars", "Avis", "First", "Tempest", "All"]
  },
  {
    vuka_id: 8,
    airport_code: "MQP",
    locationName: "Kruger Mpumalanga International Airport, Kruger National Park, Mpumalanga",
    providers: ["Europcar", "RentalCars", "Avis", "First", "Tempest", "All"]
  },
  {
    vuka_id: 9,
    airport_code: "HLA",
    locationName: "Lanseria Airport, Gauteng",
    providers: ["Europcar", "RentalCars", "Avis", "First", "Tempest", "All"]
  },
  {
    vuka_id: 11,
    airport_code: "MGH",
    locationName: "Margate, KwaZulu-Natal",
    providers: ["Europcar", "RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 14,
    airport_code: "UTT",
    locationName: "Mthatha Matanzima Airport, Eastern Cape",
    providers: ["Europcar", "RentalCars", "Avis", "First", "All"]
  },
  {
    vuka_id: 15,
    airport_code: "JNB",
    locationName: "OR Tambo International Airport, Johannesburg, Gauteng",
    providers: ["Europcar", "RentalCars", "Avis", "First", "Tempest", "All"]
  },
  {
    vuka_id: 16,
    airport_code: "PHW",
    locationName: "Hendrik Van Eck Airport, Phalaborwa, Limpopo",
    providers: ["Europcar", "RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 17,
    airport_code: "PZB",
    locationName: "Pietermaritzburg Oribi Airport, Pietermaritzburg, KwaZulu-Natal",
    providers: ["Europcar", "RentalCars", "Avis", "First", "All"]
  },
  {
    vuka_id: 19,
    airport_code: "PTG",
    locationName: "Polokwane, Limpopo",
    providers: ["Europcar", "RentalCars", "Avis", "First", "Tempest", "All"]
  },
  {
    vuka_id: 20,
    airport_code: "PLZ",
    locationName: "Port Elizabeth International Airport, Port Elizabeth, Eastern Cape",
    providers: ["Europcar", "RentalCars", "Avis", "First", "Tempest", "All"]
  },
  {
    vuka_id: 22,
    airport_code: "RCB",
    locationName: "Richards Bay Airport, KwaZulu-Natal",
    providers: ["Europcar", "RentalCars", "Avis", "First", "All"]
  },
  {
    vuka_id: 24,
    airport_code: "UTN",
    locationName: "Upington Airport, Upington, Northern Cape",
    providers: ["Europcar", "RentalCars", "Avis", "First", "Tempest", "All"]
  },
  {
    vuka_id: 25,
    locationName: "Downtown, Cape Town, Western Cape",
    providers: ["Europcar", "RentalCars", "Avis", "First", "Tempest", "All"]
  },
  {
    vuka_id: 27,
    locationName: "Downtown, Bloemfontein, Freestate",
    providers: ["Europcar", "RentalCars", "Avis", "First", "All"]
  },
  {
    vuka_id: 28,
    locationName: "Centurion, Gauteng",
    providers: ["Europcar", "RentalCars", "Avis", "First", "Tempest", "All"]
  },
  {
    vuka_id: 29,
    locationName: "Downtown, East London, Eastern Cape",
    providers: ["Europcar", "RentalCars", "Avis", "First", "All"]
  },
  {
    vuka_id: 30,
    locationName: "Empangeni, KwaZulu-Natal",
    providers: ["Avis", "All"]
  },
  {
    vuka_id: 31,
    locationName: "Downtown, George, Western Cape",
    providers: ["RentalCars", "Avis", "First", "All"]
  },
  {
    vuka_id: 33,
    locationName: "Hatfield, Gauteng",
    providers: ["Europcar", "RentalCars", "Avis", "First", "All"]
  },
  {
    vuka_id: 35,
    locationName: "Jeffreys Bay, Eastern Cape",
    providers: ["Europcar", "RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 37,
    locationName: "Kathu, Northern Cape",
    providers: ["Europcar", "RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 39,
    locationName: "Kokstad, KwaZulu-Natal",
    providers: ["Europcar", "RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 40,
    locationName: "Ladysmith, KwaZulu-Natal",
    providers: ["Europcar", "RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 42,
    locationName: "Lephalale, Limpopo",
    providers: ["RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 44,
    locationName: "Menlyn, Gauteng",
    providers: ["RentalCars", "Avis", "First", "All"]
  },
  {
    vuka_id: 47,
    locationName: "Musina, Limpopo",
    providers: ["RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 48,
    locationName: "Downtown, Nelspruit, Mpumalanga",
    providers: ["RentalCars", "Avis", "First", "All"]
  },
  {
    vuka_id: 49,
    locationName: "Newcastle, KwaZulu-Natal",
    providers: ["RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 52,
    locationName: "Pinetown, KwaZulu-Natal",
    providers: ["Europcar", "RentalCars", "Avis", "First", "All"]
  },
  {
    vuka_id: 53,
    locationName: "Port Alfred, Eastern Cape",
    providers: ["RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 54,
    locationName: "Downtown, Port Elizabeth, Eastern Cape",
    providers: ["Europcar", "RentalCars", "Avis", "First", "All"]
  },
  {
    vuka_id: 56,
    locationName: "Potchefstroom, North West",
    providers: ["RentalCars", "Avis", "First", "All"]
  },
  {
    vuka_id: 59,
    locationName: "Randburg, Johannesburg, Gauteng",
    providers: ["Europcar", "RentalCars", "Avis", "First", "Tempest", "All"]
  },
  {
    vuka_id: 61,
    locationName: "Sandton, Gauteng",
    providers: ["Europcar", "RentalCars", "Avis", "Tempest", "All"]
  },
  {
    vuka_id: 63,
    airport_code: "SZK",
    locationName: "Skukuza Airport, Skukuza, Mpumalanga",
    providers: ["RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 65,
    locationName: "Soweto, Gauteng",
    providers: ["RentalCars", "Avis", "Tempest", "All"]
  },
  {
    vuka_id: 66,
    locationName: "St Lucia, KwaZulu-Natal",
    providers: ["RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 67,
    locationName: "Stellenbosch, Western Cape",
    providers: ["Europcar", "RentalCars", "Avis", "Tempest", "All"]
  },
  {
    vuka_id: 70,
    locationName: "Umhlanga, KwaZulu-Natal",
    providers: ["Europcar", "RentalCars", "Avis", "First", "All"]
  },
  {
    vuka_id: 71,
    locationName: "Empangeni Van rental",
    providers: ["Avis", "All"]
  },
  {
    vuka_id: 73,
    locationName: "Vryburg, North West",
    providers: ["RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 74,
    locationName: "Vryheid, KwaZulu-Natal",
    providers: ["RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 75,
    locationName: "Welkom, Freestate",
    providers: ["Europcar", "RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 79,
    locationName: "Amanzimtoti, KwaZulu-Natal",
    providers: ["RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 80,
    locationName: "Ballito, KwaZulu-Natal",
    providers: ["RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 83,
    locationName: "Harrismith, Freestate",
    providers: ["RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 84,
    locationName: "Hermanus, Western Cape",
    providers: ["RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 85,
    locationName: "King WilliamsTown, Eastern Cape",
    providers: ["Avis", "All"]
  },
  {
    vuka_id: 89,
    locationName: "Rustenburg, North West",
    providers: ["Europcar", "RentalCars", "Avis", "First", "All"]
  },
  {
    vuka_id: 90,
    locationName: "Secunda, Mpumalanga",
    providers: ["Europcar", "RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 92,
    locationName: "Tzaneen, Limpopo",
    providers: ["RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 93,
    locationName: "Vereeniging, Gauteng",
    providers: ["RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 94,
    locationName: "Witbank, Mpumalanga",
    providers: ["Europcar", "RentalCars", "Avis", "First", "All"]
  },
  {
    vuka_id: 102,
    locationName: "Krugersdorp, Gauteng",
    providers: ["Europcar", "RentalCars", "Tempest", "All"]
  },
  {
    vuka_id: 106,
    locationName: "Downtown, Upington",
    providers: ["Europcar", "RentalCars", "First", "Tempest", "All"]
  },
  {
    vuka_id: 107,
    locationName: "Vanderbijlpark, Gauteng",
    providers: ["Europcar", "RentalCars", "All"]
  },
  {
    vuka_id: 1002,
    locationName: "Pretoria Brooklyn, Gauteng",
    providers: ["All"]
  },
  {
    vuka_id: 1003,
    locationName: "Thohoyandou, Limpopo",
    providers: ["All"]
  },
  {
    vuka_id: 1004,
    locationName: "Bethlehem, Freestate",
    providers: ["All"]
  },
  {
    vuka_id: 1005,
    locationName: "Mahikeng, North West",
    providers: ["All"]
  },
  {
    vuka_id: 1007,
    locationName: "Hoedspruit Downtown, Limpopo",
    providers: ["RentalCars", "Avis", "All"]
  },
  {
    vuka_id: 1008,
    locationName: "Saldanha, Western Cape",
    providers: ["All"]
  },
  {
    vuka_id: 1009,
    locationName: "Plettenberg Bay Downtown, Western Cape",
    providers: ["All"]
  },
  {
    vuka_id: 1010,
    locationName: "Plettenberg Bay Airport, Western Cape",
    providers: ["All"]
  },
  {
    vuka_id: 1011,
    locationName: "Grahamstown, Eastern Cape",
    providers: ["All"]
  },
  {
    vuka_id: 1012,
    locationName: "Rosebank, Johannesburg, Gauteng",
    providers: ["All"]
  },
  {
    vuka_id: 1013,
    locationName: "Bryanston, Johannesburg, Gauteng",
    providers: ["All"]
  },
  {
    vuka_id: 1014,
    locationName: "Tyger Valley, Western Cape",
    providers: ["All"]
  },
  {
    vuka_id: 1015,
    locationName: "Century City, Western Cape",
    providers: ["All"]
  },
  {
    vuka_id: 1016,
    locationName: "Durban City - KZN",
    providers: ["All"]
  }
];

export { allLocations, findByLocationId, filteredLocation, getLocationName };
